<div class="version-text">{{ version }}</div>
